<template src="../templates/dynamicCaldsForm.html"></template>

<script>
    import TimePicker from "./TimePickerCompomponent";

    export default {
        name: "DynamicCaldsComponent",
        props: ["whereLabel", "addNewCaldLabel", "dynamicCaldsModel"],
        components: {TimePicker},
        data() {
            return {
                caldGenders: [
                    {
                        value: 'M',
                        label: 'Male'
                    },
                    {
                        value: 'F',
                        label: 'Female'
                    }],
                tempCaldsModel: {
                	nesbs : []
				}
            }
        },
		methods: {
            removeCald(item) {
                let index = this.tempCaldsModel.nesbs.indexOf(item);
                if (index !== -1) {
                    this.tempCaldsModel.nesbs.splice(index, 1);
                }
            },
            addCald() {
                this.tempCaldsModel.nesbs.push({
                        key: Date.now(),
                        value: "",
                        name: "",
                        reference: "",
                        gender: "",
                        when: "",
                        where: "",
                        professional: ""
                    }
                );
            }
        },
        created() {
	        this.dynamicCaldsModel.nesbs.forEach((model) => {
		        this.tempCaldsModel.nesbs.push({
			        contact: model.contact,
			        key: model.key,
			        refNo: model.refNo,
			        name: model.name,
			        reference: model.reference,
			        gender: model.gender,
			        when: model.when,
			        where: model.where,
			        professional: model.professional
		        });
			});
		}
    }
</script>

<style lang="scss">
	.myCard {
		.el-card__header {
			padding: 20px !important;
			border-radius: 5px 5px 0 0;
		}
		
		h4 {
			margin: 0;
		}
		
		.el-card__body {
			border-top: 0;
			border-radius: 0 0 3px 3px;
			padding: 20px;
		}
		
		label {
			margin: 0 !important;
		}
		
		.el-form-item {
			padding: 5px !important;
		}
		
		.el-row {
			border-bottom: none !important;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/DynamicCaldsComponent.vue